/* Inter 4.1, unmodified upstream WOFF2 files; SIL Open Font License 1.1.
   One variable face per style supplies all weights and automatic optical size.
   These same-origin URLs work in Pug, Expo web and the isolated playground. */
@font-face {
  font-family: Inter;
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
  src: url('/fonts/public-glu/InterVariable-4.1.woff2') format('woff2');
}

@font-face {
  font-family: Inter;
  font-style: italic;
  font-weight: 100 900;
  font-display: swap;
  src: url('/fonts/public-glu/InterVariable-Italic-4.1.woff2') format('woff2');
}

/* Approximate Inter's text metrics while the file loads. Arial remains local;
   this fallback is not shipped as another font download. At display sizes the
   optical outlines still differ, so consumers must allow natural reflow. */
@font-face {
  font-family: 'Inter Fallback';
  font-style: normal;
  font-weight: 400;
  src: local('Arial');
  size-adjust: 105.2731%;
  ascent-override: 92.0226%;
  descent-override: 22.9129%;
  line-gap-override: 0%;
}

@font-face {
  font-family: 'Inter Fallback';
  font-style: italic;
  font-weight: 400;
  src: local('Arial Italic');
  size-adjust: 105.2731%;
  ascent-override: 92.0226%;
  descent-override: 22.9129%;
  line-gap-override: 0%;
}

@font-face {
  font-family: 'Inter Fallback';
  font-style: normal;
  font-weight: 700;
  src: local('Arial Bold');
  size-adjust: 105.2731%;
  ascent-override: 92.0226%;
  descent-override: 22.9129%;
  line-gap-override: 0%;
}

@font-face {
  font-family: 'Inter Fallback';
  font-style: italic;
  font-weight: 700;
  src: local('Arial Bold Italic');
  size-adjust: 105.2731%;
  ascent-override: 92.0226%;
  descent-override: 22.9129%;
  line-gap-override: 0%;
}
